import VueTypes, { nullable } from 'vue-types';

const itemTypes = ['link', 'image', 'tagLink', 'html', 'text', 'enumIcons'];

export const ColumnItemStructure = VueTypes.shape({
    id: VueTypes.number.isRequired,
    label: VueTypes.oneOfType([String, nullable]).def(null),
    type: VueTypes.oneOf(itemTypes).isRequired,
    link: VueTypes.oneOfType([String, nullable]).def(null),
    scroll: VueTypes.bool.def(false),
}).isRequired;

export const ColumnStructure = VueTypes.shape({
    title: VueTypes.oneOfType([String, nullable]).def(null),
    items: VueTypes.arrayOf(ColumnItemStructure).def(null)
}).isRequired;

export const createColumnItemStructure = ({ id, label, type, link, image, subItems, html, classes }) => {
    return {
        id: id,
        label: label,
        type: type,
        link: link,
        image: image,
        subItems: subItems,
        html: html,
        classes: classes
    };
};

export const createColumnStructure = ({ title, items }) => {
    return {
        title: title,
        items: items
    };
};
